<template>
  <div class="vs-modal">
    <button
      class="button is-white is-small is-pulled-right"
      @click="$emit('close')"
    >
      <font-awesome-icon
        class="vs-icon"
        icon="times"
      />
    </button>
    <div class="vs-modal_body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.vs-modal {
  width: 100%;
  min-height: 200px;
  background-color: $white;

  .vs-modal_body {
    padding: 32px;
  }
}
</style>
